import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { StatusCount } from '@models/overviewData';

@Injectable({
  providedIn: 'root',
})
export class WorkerDashboardService {
  constructor(protected http: HttpClient) {}

  getData(): Observable<StatusCount[]> {
    return this.http.get<StatusCount[]>(
      `${environment.apiUrls.workflow}/api/v1/dashboard/worker/status-count`,
    );
  }
}
